import React from "react"

import { ThumbSlide } from "../../../styles/FrontPageFlavorStyles"

import { MilkshakeCottonCandyThumb } from "./MilkshakeCottonCandy"
import { MilkshakeVanillaBlissThumb } from "./MilkshakeVanillaBliss"
import { MilkshakeChocolateChillThumb } from "./MilkshakeChocolateChill"
import { MilkshakeReesesPBCupThumb } from "./MilkshakeReesesPBCup"
import { MilkshakeOreoCookiesCreamThumb } from "./MilkshakeOreoCookiesCream"

import { SmoothieStrawberryBananaThumb } from "./SmoothieStrawberryBanana"
import { SmoothieMangoThumb } from "./SmoothieMango"

export default function EnglishThumbs(props) {
  const { activeIndex, setActiveIndex } = props

  return (
    <>
      <ThumbSlide onClick={e => setActiveIndex(0)}>
        <MilkshakeCottonCandyThumb active={activeIndex === 0} />
      </ThumbSlide>
      <ThumbSlide onClick={e => setActiveIndex(1)}>
        <MilkshakeVanillaBlissThumb active={activeIndex === 1} />
      </ThumbSlide>
      <ThumbSlide onClick={e => setActiveIndex(2)}>
        <MilkshakeChocolateChillThumb active={activeIndex === 2} />
      </ThumbSlide>
      <ThumbSlide onClick={e => setActiveIndex(3)}>
        <MilkshakeReesesPBCupThumb active={activeIndex === 3} />
      </ThumbSlide>
      <ThumbSlide onClick={e => setActiveIndex(4)}>
        <MilkshakeOreoCookiesCreamThumb active={activeIndex === 4} />
      </ThumbSlide>

      <ThumbSlide onClick={e => setActiveIndex(5)}>
        <SmoothieStrawberryBananaThumb active={activeIndex === 5} />
      </ThumbSlide>
      <ThumbSlide onClick={e => setActiveIndex(6)}>
        <SmoothieMangoThumb active={activeIndex === 6} />
      </ThumbSlide>
    </>
  )
}
